<template>
  <DashboardTemplate :navMenu="true">
    <div class="box-overflow dashboard">
      <div>
        <h3 class="text-left text-font-24 mg-y-less">ข้อมูลสรุปของหลักสูตร (Dashboard)</h3>
      </div>
      <el-tabs v-model="activeName" class="text-font-16 mg-t-4">
        <el-tab-pane label="ภาพรวมหลักสูตรทั้งหมด" name="1">
          <div v-if="activeName == '1'" class="pd-y-4">
            <DashboardCourseTotalList/>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="ภาพรวมแต่ละหลักสูตร"
          name="2"
        >
          <div v-if="activeName == '2'" class="pd-y-4">
            <DashboardCourseById/>
          </div>
        </el-tab-pane>
      </el-tabs>

     
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import DashboardCourseById from "@/components/dashboard/DashboardCourseById";
import DashboardCourseTotalList from "@/components/dashboard/DashboardCourseTotalList";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DashboardTemplate,
    DashboardCourseById,
    DashboardCourseTotalList
  },
  data() {
    return {
      activeName:'1'
    }
  },
  
};
</script>
